import React, { memo } from 'react';

/**
 * TableContainer - Componente de presentación puro ("tonto") y memoizado.
 * Provee un contenedor con scrollbars customizados de alta fidelidad,
 * asegurando un ancho mínimo de tabla y comportamiento table-fixed inalterable.
 * * @param {React.ReactNode} children - El contenido interno de la tabla (thead, tbody, etc.).
 * @param {string} minWidth - Ancho mínimo de la grilla para forzar el scroll horizontal (Default: "3200px").
 * @param {string} className - Clases CSS adicionales de Tailwind para personalizar el contenedor.
 */
const TableContainer = memo(({ 
    children, 
    minWidth = "3200px", 
    className = "" 
}) => {
    return (
        <div className={`flex-grow overflow-hidden flex flex-col bg-white text-left ${className}`}>
            {/* Contenedor de scroll bidireccional */}
            <div className="overflow-x-auto overflow-y-auto custom-scrollbar h-full w-full relative">
                <table 
                    className="w-full text-left border-separate border-spacing-0 table-fixed" 
                    style={{ minWidth }}
                >
                    {children}
                </table>
            </div>

            {/* Inyección de estilos de scrollbar táctiles y responsivos */}
            <style dangerouslySetInnerHTML={{ __html: `
                .custom-scrollbar::-webkit-scrollbar { 
                    height: 10px; 
                    width: 6px; 
                }
                .custom-scrollbar::-webkit-scrollbar-track { 
                    background: #f1f5f9; 
                }
                .custom-scrollbar::-webkit-scrollbar-thumb { 
                    background: #cbd5e1; 
                    border-radius: 10px; 
                    border: 2px solid #f1f5f9; 
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { 
                    background: #94a3b8; 
                }
                .tabular-nums { 
                    font-variant-numeric: tabular-nums; 
                }
            `}} />
        </div>
    );
});

TableContainer.displayName = 'TableContainer';

export default TableContainer;